import React from 'react';
import styles from '../../../styles/automation/nlpautomation.module.scss';
import ButtonComponent from '../../customButton/index';
import { setActivePage } from '../../../features/navigation/navigationSlice';
import { useDispatch, useSelector } from 'react-redux';
import DEFAULT_ROUTES from '../../../constants/routes';

export default function NoPlanFound({ testCaseId }) {
    const dispatch = useDispatch();
    const selectedProject = useSelector((state) => state?.projects?.selectedProject);

    const openInStudio = () => {
        dispatch(setActivePage('Automation Studio'));
        const url = `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}/${selectedProject?.id}${DEFAULT_ROUTES.AUTOMATION_STUDIO}/${testCaseId}`;
        window.open(url, '_blank');
    }

    return (
        <div className={styles.noPlanFoundContainer}>
            <div className={styles.noPlanFoundContent}>
                <h1>No Automation Plan Found</h1>
                <p>There is currently no automation plan for this test case. Open in Automation Studio to create one.</p>
                <ButtonComponent ctaText="Open in Automation Studio" onClick={openInStudio} className='bg-primary white' />
            </div>
        </div>
    );
}